  // import { useState } from "react";
  // import { useNavigate } from "react-router-dom";
  // import "./FullPayment.css";
  // import Loader from "../../../Template/Loader/Loader";
  // import { putPaymentBooking } from "../../../utils/APIs/bookingApis";
  // import CommonMessageModal from "../../CommonMessageModal/CommonMessageModal";

  // const FullPayment = ({ serviceCost = 0, bookingId }) => {
  //   const navigate = useNavigate();

  //   const [promoCode, setPromoCode] = useState("");
  //   const [loading, setLoading] = useState(false);
  //   const [showModal, setShowModal] = useState(false);
  //   const [modalMessage, setModalMessage] = useState("");
  //   const [isPaymentSuccess, setIsPaymentSuccess] = useState(false); // ✅ success flag

  //   const getFormattedDate = () => {
  //     const date = new Date();
  //     const day = String(date.getDate()).padStart(2, "0");
  //     const month = String(date.getMonth() + 1).padStart(2, "0");
  //     const year = date.getFullYear();
  //     return `${day}-${month}-${year}`;
  //   };

  //   const handleFullPayment = async () => {
  //     try {
  //       if (!bookingId) {
  //         setIsPaymentSuccess(false);
  //         setModalMessage("Booking ID not found. Please try again.");
  //         setShowModal(true);
  //         return;
  //       }

  //       setLoading(true);

  //       const payload = {
  //         partial_Payment: false,
  //         full_Payment: true,
  //         outStandingAmount: 0,
  //         paymentStatus: "fully paid",
  //         paymentDate: getFormattedDate(),
  //         paymentMode: "online",
  //       };

  //       const response = await putPaymentBooking(bookingId, payload);

  //       if (response.data?.success) {
  //         setIsPaymentSuccess(true); // ✅ mark success
  //         setModalMessage("Payment completed successfully.");
  //       } else {
  //         setIsPaymentSuccess(false);
  //         setModalMessage(response.data?.message || "Payment failed.");
  //       }

  //       setShowModal(true);
  //     } catch (error) {
  //       setIsPaymentSuccess(false);
  //       setModalMessage(
  //         error.response?.data?.message || "Payment failed. Please try again."
  //       );
  //       setShowModal(true);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   return (
  //     <>
  //       {loading && <Loader />}

  //       <div className="full-payment-container">
  //         <div className="full-payment-content">

  //           {/* PROMO CODE */}
  //           <div className="promo-code-section">
  //             <h3 className="promo-title">Have a promo code?</h3>
  //             <div className="promo-input-group">
  //               <input
  //                 type="text"
  //                 placeholder="Enter Code"
  //                 value={promoCode}
  //                 onChange={(e) => setPromoCode(e.target.value)}
  //                 className="promo-input"
  //               />
  //               <button className="btn-apply">Apply</button>
  //             </div>
  //           </div>

  //           {/* PAYMENT SUMMARY */}
  //           <div className="payment-summary-single">
  //             <span className="summary-label-single">
  //               Total Payable Amount
  //             </span>
  //             <span className="summary-amount-single">
  //               ₹{serviceCost}
  //             </span>
  //           </div>

  //           {/* CONTINUE BUTTON */}
  //           <button
  //             className="btn-continue-payment"
  //             onClick={handleFullPayment}
  //             disabled={loading}
  //           >
  //             Continue to Payment
  //           </button>

  //         </div>
  //       </div>

  //       {/* SUCCESS / ERROR MODAL */}
  //       <CommonMessageModal
  //         show={showModal}
  //         message={modalMessage}
  //         onClose={() => {
  //           setShowModal(false);
  //           if (isPaymentSuccess) {
  //             navigate("/booking-success"); // ✅ navigate ONLY on success
  //           }
  //         }}
  //       />
  //     </>
  //   );
  // };

  // export default FullPayment;



  import { useState , useEffect } from "react";
  import { useNavigate } from "react-router-dom";
  import "./FullPayment.css";
  // 
  import Loader from "../../../Template/Loader/Loader";
  import { validateCoupon } from "../../../utils/APIs/cartApis";
  import { toast } from "react-toastify";
  // import { createRazorpayOrder, verifyRazorpayPayment } from "../../../utils/APIs/bookingApis";
  import CommonMessageModal from "../../CommonMessageModal/CommonMessageModal";
  // import { createRazorpayOrder, verifyRazorpayPayment } from "../../../utils/APIs/razorpayPaymentApis";
  import { GetProfile } from "../../../utils/APIs/myProfileApis";
  import { createRazorpayOrder, verifyRazorpayPayment } from "../../../utils/APIs/razorpayPaymentApis";
  const FullPayment = ({ serviceCost = 0, bookingId, fromQuoteFlow = false }) => {
    const navigate = useNavigate();

    const navigateAfterSuccess = () => {
      if (fromQuoteFlow && bookingId) {
        const quoteChatId = sessionStorage.getItem("activeChatId");
        if (quoteChatId) {
          sessionStorage.setItem("quoteChatReturnId", quoteChatId);
        }
        navigate(`/quote-event-address/${bookingId}`, { replace: true });
      } else {
        navigate("/booking-success", { replace: true });
      }
    };

    const [promoCode, setPromoCode] = useState("");
    const [couponApplied, setCouponApplied] = useState(false);
    const [discountAmount, setDiscountAmount] = useState(0);
    const [couponLoading, setCouponLoading] = useState(false);
    const [appliedCouponId, setAppliedCouponId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [modalMessage, setModalMessage] = useState("");
    const [isPaymentSuccess, setIsPaymentSuccess] = useState(false);
    const [userDetails, setUserDetails] = useState({
      username: "User Name", // Consider fetching real user details if available
      email: "user@example.com",
      mobileNumber: "9999999999",
    });

    useEffect(() => {
      const fetchUserDetails = async () => {
        try {
          const response = await GetProfile();
          if (response.data?.success) {
            setUserDetails(response.data);
          }
        } catch (error) {
          console.error("Error fetching user details:", error);
        }
      };

      fetchUserDetails();
    }, []);

    const activePaymentId = bookingId;
    const finalPayable = Math.max(0, serviceCost - discountAmount);

    const handleApplyPromoCode = async () => {
      if (!promoCode) {
        toast.error("Please enter a promo code");
        return;
      }
      try {
        setCouponLoading(true);
        const res = await validateCoupon({
            code: promoCode,
            amount: serviceCost,
            couponType: "Service"
        });

        if (res?.data?.success) {
            const appliedCoupon = res.data.coupon;
            let currentDiscount = 0;
            if (appliedCoupon.discountType === "percentage") {
                currentDiscount = (serviceCost * appliedCoupon.discountValue) / 100;
            } else if (appliedCoupon.discountType === "flat") {
                currentDiscount = Math.min(appliedCoupon.discountValue, serviceCost);
            }
            setDiscountAmount(currentDiscount);
            setCouponApplied(true);
            setAppliedCouponId(appliedCoupon._id);
            toast.success(res.data.message || "Promo code applied successfully!");
        } else {
            toast.error(res?.data?.message || "Invalid promo code");
        }
      } catch (error) {
          console.error("Error applying promo code:", error);
          toast.error(error?.response?.data?.message || "Failed to apply promo code");
      } finally {
          setCouponLoading(false);
      }
    };

    const handleRemovePromoCode = () => {
        setPromoCode("");
        setDiscountAmount(0);
        setCouponApplied(false);
        setAppliedCouponId(null);
        toast.info("Promo code removed");
    };

    const loadRazorpayScript = () => {
      return new Promise((resolve) => {
        const script = document.createElement("script");
        script.src = "https://checkout.razorpay.com/v1/checkout.js";
        script.onload = () => resolve(true);
        script.onerror = () => resolve(false);
        document.body.appendChild(script);
      });
    };

    const handleFullPayment = async () => {
      try {
        if (!activePaymentId) {
          setIsPaymentSuccess(false);
          setModalMessage("Payment ID not found. Please try again.");
          setShowModal(true);
          return;
        }

        setLoading(true);

        const res = await loadRazorpayScript();
        if (!res) {
          setIsPaymentSuccess(false);
          setModalMessage("Razorpay SDK failed to load. Are you online?");
          setShowModal(true);
          setLoading(false);
          return;
        }

        // Step 1: Create Order
        const orderPayload = {
          bookingId: activePaymentId,
          paymentType: "full",
          couponId: appliedCouponId,
          discountAmount: discountAmount
        };

        const orderResponse = await createRazorpayOrder(orderPayload);

        if (!orderResponse.data?.success) {
          setIsPaymentSuccess(false);
          setModalMessage(orderResponse.data?.message || "Failed to create payment order.");
          setShowModal(true);
          setLoading(false);
          return;
        }

        const { order } = orderResponse.data;

        // Step 2: Open Razorpay Checkout
        const options = {
          key: process.env.REACT_APP_RAZORPAY_KEY_ID || "rzp_test_SVlHgQL1Trpo1W", // Fallback to provided test key
          amount: order.amount,
          currency: order.currency,
          name: "Veroa Photography",
          description: "Full Payment for Service",
          order_id: order.id,
          handler: async function (response) {
            try {
              setLoading(true);
              const verifyPayload = {
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
                bookingId: activePaymentId,
                couponId: appliedCouponId,
                discountAmount: discountAmount
              };

              const verifyResponse = await verifyRazorpayPayment(verifyPayload);

              if (verifyResponse.data?.success) {
                setIsPaymentSuccess(true);
                navigateAfterSuccess();
              } else {
                setIsPaymentSuccess(false);
                setModalMessage(verifyResponse.data?.message || "Payment verification failed.");
                setShowModal(true);
              }
            } catch (verifyError) {
              setIsPaymentSuccess(false);
              setModalMessage(verifyError.response?.data?.message || "Payment verification failed. Please try again.");
              setShowModal(true);
            } finally {
              setLoading(false);
            }
          },
          prefill: {
            name: userDetails?.username || "User Name", // Consider fetching real name if available
            email: userDetails?.email || "user@example.com",
            contact: userDetails?.mobileNumber || "9999999999",
          },
          theme: {
            color: "#4A3326",
          },
        };

        const paymentObject = new window.Razorpay(options);
        
        paymentObject.on('payment.failed', function (response) {
          setIsPaymentSuccess(false);
          setModalMessage(response.error.description || "Payment failed.");
          setShowModal(true);
        });

        paymentObject.open();
        setLoading(false); // Hide loader while modal is open

      } catch (error) {
        setIsPaymentSuccess(false);
        setModalMessage(
          error.response?.data?.message || "Payment initiation failed. Please try again."
        );
        setShowModal(true);
        setLoading(false);
      }
    };





  // const handleFullPayment = async () => {
  //   try {
  //     if (!activePaymentId) {
  //       setModalMessage("Payment ID not found");
  //       setShowModal(true);
  //       return;
  //     }

  //     setLoading(true);

  //     // 1️⃣ Create Order
  //     const { data } = await createRazorpayOrder(serviceCost);
  //     const order = data.order;

  //     // 2️⃣ Razorpay Options
  //     const options = {
  //       key: process.env.REACT_APP_RAZORPAY_KEY_ID,
  //       amount: order.amount,
  //       currency: "INR",
  //       name: "Your Company",
  //       description: "Full Payment",
  //       order_id: order.id,

  //       handler: async function (response) {
  //         try {
  //           // 3️⃣ Verify Payment
  //           const verifyRes = await verifyRazorpayPayment(response);

  //           if (verifyRes.data.success) {
  //             // 4️⃣ Update Booking
  //             const payload = {
  //               partial_Payment: false,
  //               full_Payment: true,
  //               outStandingAmount: 0,
  //               paymentStatus: "fully paid",
  //               paymentDate: getFormattedDate(),
  //               paymentMode: "online",
  //               razorpay_payment_id: response.razorpay_payment_id,
  //             };

  //             await putPaymentBooking(activePaymentId, payload);

  //             setIsPaymentSuccess(true);
  //             setModalMessage("Payment successful!");
  //           } else {
  //             setIsPaymentSuccess(false);
  //             setModalMessage("Payment verification failed");
  //           }

  //           setShowModal(true);
  //         } catch (err) {
  //           setModalMessage("Verification error");
  //           setShowModal(true);
  //         }
  //       },

  //       prefill: {
  //         name: "Customer Name",
  //         email: "test@email.com",
  //         contact: "9999999999",
  //       },

  //       theme: {
  //         color: "#3399cc",
  //       },
  //     };

  //     const rzp = new window.Razorpay(options);
  //     rzp.open();

  //   } catch (error) {
  //     setModalMessage("Payment failed");
  //     setShowModal(true);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
    return (
      <>
        {loading && <Loader />}

        <div className="full-payment-container">
          <div className="full-payment-content">

            {/* PROMO CODE */}
            <div className="promo-code-section">
              <h3 className="promo-title">Have a promo code?</h3>
              <div className="promo-input-group">
                <input
                  type="text"
                  placeholder="Enter Code"
                  value={promoCode}
                  onChange={(e) => setPromoCode(e.target.value)}
                  className="promo-input"
                  disabled={couponApplied}
                />
                <button 
                  className="btn-apply"
                  disabled={couponLoading}
                  onClick={() => couponApplied ? handleRemovePromoCode() : handleApplyPromoCode()}
                >
                  {couponLoading ? "Applying..." : (couponApplied ? "Remove" : "Apply")}
                </button>
              </div>
            </div>

            {/* PAYMENT SUMMARY */}
            <div className="payment-summary-single">
              <span className="summary-label-single">
                Total Payable Amount
              </span>
              <span className="summary-amount-single">
                {String(finalPayable || "").trim().startsWith("₹") ? "" : "₹"}{finalPayable}
              </span>
            </div>

            {/* CONTINUE BUTTON */}
            <button
              className="btn-continue-payment"
              onClick={handleFullPayment}
              disabled={loading}
            >
              Continue to Payment
            </button>

          </div>
        </div>

        {/* SUCCESS / ERROR MODAL */}
        <CommonMessageModal
          show={showModal}
          message={modalMessage}
          onClose={() => {
            setShowModal(false);
            if (isPaymentSuccess) {
              navigateAfterSuccess();
            }
          }}
        />
      </>
    );
  };

  export default FullPayment;
